<template>
  <div style="padding: 5px; margin-top: 5px;">
    <div class="coupon-list" v-for="item in list" :key="item.stockId" style="padding: 5px" @click="clickImg(item.stockId)">
      <van-image :src="item.imgUrl" fit="fill" radius="6" height="140"/>
    </div>
  </div>
</template>

<script>
import carInspectionCoupon from "@/api/carInspectionCoupon";

export default {
  name: "index",
  data() {
    return {
      groupId: "1725037736538296322",
      list: [
        {
          "endtime": "2023-11-17 23:00:00",
          "starttime": "2023-11-17 00:00:00",
          "title": "车检活动满70减5",
          "imgUrl": "https://oss.letouros.com/letour/a4576d0cde194540ba75b0eafeea521c.png",
          "stockId": "1288870000000204",
          "id": ""
        },
        {
          "endtime": "2023-11-18 23:00:00",
          "starttime": "2023-11-18 00:00:00",
          "title": "车检活动满70减5",
          "imgUrl": "https://oss.letouros.com/letour/951c5be782604235b716cf11b836abb5.png",
          "stockId": "1288870000000202",
          "id": ""
        }
      ],

    }
  },
  methods: {
    getList() {
    /*  carInspectionCoupon.getListByGroupId({groupId: this.groupId}).then(res => {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(res))
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })*/
    },
    clickImg(stockId){
      carInspectionCoupon.receiveCoupon({stockId: stockId}).then(res => {
        // eslint-disable-next-line no-console
        // console.log(JSON.stringify(res.data))
        window.location.href = res.data
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    }
  }
}
</script>

<style scoped>

</style>
